// https://dev.to/collegewap/how-to-work-with-radio-buttons-in-react-3e0o

// Third party modules;
import React from 'react';

// HelpBot modules;
import app from './app';
import { Form, FORM, form_close } from './Form';

const SetVersion = () => {

   const [user_access_id, set_user_access_id] = React.useState(app.state.user_access_id);

   const build = async ({ set_body, set_foot, ...args }) => {
      // The build() function sets the body and foot componenets and waits for the user to 
      // initiate an action on the form such as an option select, text input or submit;

      var content   = [];

      var key_index = 1;

      const list    = app.state.user_access_list;
      for (var ith = 0; ith < list.length; ith++) {
         var role = 'read';
         if (list[ith].user_is_writer) role = 'write';
         if (list[ith].user_is_admin)  role = 'admin';
         content.push(
            <tr key={key_index++}>
              <td className="app-henry-form-grid-app-button">
                <input defaultChecked={ith === app.state.user_access_id}  name="user_access_id" onChange={build_click} type="radio" value={ith} />
              </td>
              <td>{list[ith].version_id}</td>
              <td className="app-henry-form-grid-app-app">{list[ith].application_name}</td>
              <td className="app-henry-form-grid-version">{list[ith].version_name}</td>
              <td className="app-henry-form-grid-version">{role}</td>
              <td className="app-henry-form-grid-version">{list[ith].version_is_active ? 'YES' : 'no'}</td>
              <td className="app-henry-form-grid-version">{list[ith].version_is_published ? 'YES' : 'no'}</td>
            </tr>
         );
      }

      set_body(
         <div className="ask-henry-body-margin-bottom-x">
           <table className="ask-henry-data-grid">
             <tbody>
             <tr><td></td><td>Id</td><td>Application</td><td>Version</td><td>Your Role</td><td>Active</td><td>Pubished</td></tr>
             {content}
             </tbody>
           </table>
         </div>
      );

      set_foot(
         <>
           <button className="ask-henry-form-button" type="submit">Set Version</button>
           <button className="ask-henry-form-button" onClick={form_close}>Cancel</button>
         </>
      );

   } // build();

   const build_click = (e) => {
      const value = e.target.value;
      set_user_access_id(value);
   } // build_click();

   const enact = ({ set_form, ...args }) => {
      // The enact() function does the actual work given the user inputs and options;

      app.set_state('user_access_id', user_access_id, false);
      app.set_state('status', 'Set application version ' + app.state.user_access_list[user_access_id].version_id, false);
      app.set_state('mode', null);

      const help   = document.getElementById('help');
      const script = document.createElement('script');
      const url    = new URL(window.location.href);
      var host     = url.host;
      if (url.port) host = host.substr(0, host.length - url.port.length - 1);

      // script.setAttribute('data', app.state.user_access_list[user_access_id].version_id);
      script.setAttribute('defer', '');
      script.setAttribute('id', 'research-helpbot-script');
      script.setAttribute('slug', app.state.user_access_list[user_access_id].application_name.toLowerCase());
      script.setAttribute('src', app.host + '/research-helpbot.js');
      script.setAttribute('type', 'text/javascript');
      if (help.lastChild) help.removeChild(help.lastChild);
      help.appendChild(script);
      set_form(FORM.FINAL);

   } // enact();

   return <Form build={build} class_string="ask-henry-form-set-version" enact={enact} title="Set Version" />

} // <SetVersion />;

export default SetVersion;
